import { render, staticRenderFns } from "./headerNav.vue?vue&type=template&id=53881048"
import script from "./headerNav.vue?vue&type=script&lang=js"
export * from "./headerNav.vue?vue&type=script&lang=js"
import style0 from "./headerNav.vue?vue&type=style&index=0&id=53881048&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports